import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { useEffect, useState } from 'react';

interface IGeneralLoading {
  size: number;
  text?: string;
  fontVariant?: TypographyProps['variant'];
  withDots?: boolean;
}

const GeneralLoading = ({
  size,
  text = 'Cargando',
  fontVariant = 'body1',
  withDots = false,
}: IGeneralLoading) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    if (!withDots) return;

    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 3 ? prev + '.' : ''));
    }, 500);

    return () => clearInterval(interval);
  }, [withDots]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
      <CircularProgress size={size} aria-label="loading" />
      {text && (
        <Typography variant={fontVariant} color="secondary">
          {text}
          {withDots && dots}
        </Typography>
      )}
    </Box>
  );
};

export default GeneralLoading;
